import React from 'react';
import { ParallaxImage } from './ParallaxImage';
import { QuoteCard } from './QuoteCard';
import { Button } from './Button';
import { Input } from './Input';
import { Label } from './Label';
import { Card, CardContent, CardHeader, CardTitle } from './Card';
import { Star, ShieldCheck, Award } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-[90vh] flex items-center pt-10 pb-20 lg:py-0" data-id="element-142">
      <div className="absolute inset-0 z-0" data-id="element-143">
        <ParallaxImage src="https://cdn.magicpatterns.com/uploads/wkvwzztfNp6W8vy3hPFA54/TXD-Roofing6.jpg" alt="Aerial view of a Texas Direct crew replacing the roof on a large DFW home" className="w-full h-full" overlayClassName="bg-gradient-to-r from-tx-deep/95 via-tx-deep/80 to-tx-deep/40" data-id="element-144" />
      </div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-145">
        <div className="grid lg:grid-cols-12 gap-12 items-center" data-id="element-146">
          {/* Hero Content */}
          <div className="lg:col-span-7 xl:col-span-8 text-white" data-id="element-147">
            <div className="flex flex-wrap items-center gap-4 mb-6 text-sm font-medium text-white/90" data-id="element-148">
              <div className="flex items-center gap-1.5" data-id="element-149">
                <Star className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-150" />
                <span data-id="element-151">450+ 5-Star Reviews</span>
              </div>
              <span className="hidden sm:inline opacity-50" data-id="element-152">•</span>
              <div className="flex items-center gap-1.5" data-id="element-153">
                <ShieldCheck className="w-4 h-4 text-tx-red" data-id="element-154" />
                <span data-id="element-155">Lifetime Labor Warranty</span>
              </div>
              <span className="hidden sm:inline opacity-50" data-id="element-156">•</span>
              <div className="flex items-center gap-1.5" data-id="element-157">
                <Award className="w-4 h-4 text-blue-400" data-id="element-158" />
                <span data-id="element-159">Owens Corning Platinum Preferred</span>
              </div>
            </div>

            <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-extrabold leading-[1.1] mb-6 tracking-tight" data-id="element-160">
              DFW's Trusted Storm <br className="hidden sm:block" data-id="element-161" />
              Damage Roofer
            </h1>

            <p className="text-lg sm:text-xl text-white/90 mb-10 max-w-2xl leading-relaxed" data-id="element-162">
              Free inspections and same-day response across Dallas Fort Worth.
              Roof repairs, full replacements, and insurance claim experts since
              2017.
            </p>

            <div className="flex flex-col sm:flex-row gap-4" data-id="element-163">
              <Button className="bg-tx-red hover:bg-tx-red/90 text-white font-bold px-8 h-14 rounded-lg text-lg" data-id="element-164">
                Get My Free Inspection
              </Button>
              <Button variant="outline" className="bg-transparent border-2 border-white text-white hover:bg-white/10 font-bold px-8 h-14 rounded-lg text-lg" data-id="element-165">
                Call (817) 775-3540
              </Button>
            </div>
          </div>

          {/* Lead Form Card */}
          <div className="lg:col-span-5 xl:col-span-4" data-id="element-166">
            <Card className="bg-white/95 backdrop-blur-sm border-0 shadow-2xl rounded-xl overflow-hidden" data-id="element-167">
              <div className="bg-tx-navy p-4 text-center" data-id="element-168">
                <h3 className="text-white font-bold text-lg" data-id="element-169">
                  Request Your Free Inspection
                </h3>
              </div>
              <CardContent className="p-6" data-id="element-170">
                <form className="space-y-4" onSubmit={e => e.preventDefault()} data-id="element-171">
                  <div className="space-y-2" data-id="element-172">
                    <Label htmlFor="hero-name" className="text-tx-body font-semibold" data-id="element-173">
                      Full Name
                    </Label>
                    <Input id="hero-name" placeholder="John Doe" className="h-12 bg-gray-50" data-id="element-174" />
                  </div>
                  <div className="space-y-2" data-id="element-175">
                    <Label htmlFor="hero-phone" className="text-tx-body font-semibold" data-id="element-176">
                      Phone Number
                    </Label>
                    <Input id="hero-phone" type="tel" placeholder="(817) 555-0123" className="h-12 bg-gray-50" data-id="element-177" />
                  </div>
                  <div className="space-y-2" data-id="element-178">
                    <Label htmlFor="hero-zip" className="text-tx-body font-semibold" data-id="element-179">
                      Zip Code
                    </Label>
                    <Input id="hero-zip" placeholder="76053" className="h-12 bg-gray-50" data-id="element-180" />
                  </div>
                  <Button className="w-full bg-tx-red hover:bg-tx-red/90 text-white font-bold h-14 rounded-lg text-lg mt-2" data-id="element-181">
                    Get My Free Inspection
                  </Button>
                  <p className="text-xs text-center text-gray-500 mt-4" data-id="element-182">
                    By submitting, you agree to our privacy policy. No
                    obligation.
                  </p>
                </form>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>

      {/* Floating 60-second quote card */}
      <div className="hidden xl:block absolute bottom-8 left-8 z-20 w-[360px]" data-id="element-183">
        <QuoteCard compact data-id="element-184" />
      </div>
    </section>;
}